import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withCustomValidation } from '@bingads-webui-react/validation';
import { AdStatus } from './index';

export const AdStatusWithCustomValidation = ({
  validationProps, updateValidation,
}) => {
  const { data } = validationProps;
  const status = data && data.AdStatus;

  const handleStatusChange = useCallback((newData) => {
    updateValidation([], { AdStatus: newData });
  }, [updateValidation]);

  useEffect(() => {
    updateValidation([], { AdStatus: status || 'Active' });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // only run onece

  return <AdStatus onAdStatusChange={handleStatusChange} data={status} />;
};

AdStatusWithCustomValidation.propTypes = {
  validationProps: PropTypes.shape({
    data: PropTypes.shape({
      AdStatus: PropTypes.string,
    }),
  }).isRequired,
  updateValidation: PropTypes.func.isRequired,
};

export const ValidatedAdStatus = withCustomValidation(AdStatusWithCustomValidation);
